/**
 * Convert a display method signature (with param names) to a function prototype.
 * Example: "withdraw(uint256 depositId)" -> "withdraw(uint256)"
 */
export function convertMethodSignatureToPrototype(methodSignature: string): string {
  const match = methodSignature.match(/^(\w+)\((.*)\)$/);
  if (!match) return methodSignature;
  const functionName = match[1];
  const paramsString = match[2];
  if (!paramsString.trim()) return `${functionName}()`;
  const params = splitTopLevelParams(paramsString).map(extractParamType);
  return `${functionName}(${params.join(',')})`;
}

function splitTopLevelParams(paramsString: string): string[] {
  const result: string[] = [];
  let depth = 0;
  let current = '';
  for (const ch of paramsString) {
    if (ch === '<' || ch === '(') depth += 1;
    else if (ch === '>' || ch === ')') depth = Math.max(0, depth - 1);
    else if (ch === ',' && depth === 0) {
      if (current.trim()) result.push(current.trim());
      current = '';
      continue;
    }
    current += ch;
  }
  if (current.trim()) result.push(current.trim());
  return result;
}

function extractParamType(param: string): string {
  const trimmed = param.trim();
  if (!trimmed) return trimmed;
  let typeEnd = 0;
  let depth = 0;
  for (let i = 0; i < trimmed.length; i += 1) {
    const ch = trimmed[i];
    if (ch === '<' || ch === '(' || ch === '[') depth += 1;
    else if (ch === '>' || ch === ')' || ch === ']') depth = Math.max(0, depth - 1);
    else if (/\s/.test(ch) && depth === 0) {
      typeEnd = i;
      break;
    }
    typeEnd = i + 1;
  }
  return trimmed.slice(0, typeEnd).trim() || trimmed;
}
